const initialState = {
  assets: [],
  loading: false,
  error: null,
  actionLoading: false,
  selectedAsset: null
};

const AssetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_ASSETS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_ASSETS_SUCCESS':
      return { ...state, loading: false, assets: action.payload, error: null };
    case 'FETCH_ASSETS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'FETCH_ASSET_BY_ID_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'FETCH_ASSET_BY_ID_SUCCESS':
      return { ...state, actionLoading: false, selectedAsset: action.payload, error: null };
    case 'FETCH_ASSET_BY_ID_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'ADD_ASSET_REQUEST':
    case 'UPDATE_ASSET_REQUEST':
    case 'DELETE_ASSET_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'ADD_ASSET_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        assets: [action.payload, ...state.assets],
        error: null
      };

    case 'UPDATE_ASSET_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        assets: state.assets.map((p) => (p.assetsId === action.payload.assetsId ? action.payload : p)),
        selectedAsset: action.payload,
        error: null
      };

    case 'DELETE_ASSET_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        assets: state.assets.filter((p) => p.assetsId !== action.payload),
        error: null
      };

    case 'ADD_ASSET_FAILURE':
    case 'UPDATE_ASSET_FAILURE':
    case 'DELETE_ASSET_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default AssetsReducer;
